module.exports = __webpack_public_path__ + "img/bangflag@2x.6e733d36.png";